/* global jQuery */
/* global _ */
/**
 * Default Form-Functionalities:
 * - validation
 * - belongsto
 * - showpassword
 * @author RMa, Unic AG
 * @edited HaJ, Unic AG
 * @license All rights reserved Unic AG
 */

;(function($, undefined) {
	'use strict';

	var $document = $(document),
		name = 'flexform',
		events = {
			EVENT_VALIDATION_INVALID: name + '_validation_invalid'
		},
		defaults = {
			validationOptions: {
				focusInvalid: true,
				ignore: ':hidden, [readonly=readonly]'
			},
			cssprefix: 'flex',
			dovalidation: true,
			initplaceholder: false,
			dataattribute: name, // configurable because of legacy implementations in Post
			displayStyle: '' // LLBNOVUS-1070 - remember CSS display style
		},
		constants = {
			haserrorClass: 'flex_has_error'
		},
		data = {
		// items: ["Item 1", "Item 2"]
	};

	name = name.toLowerCase();

	/**
	 * Create an instance of the module
	 * @param {object} element The DOM element to bind the module
	 * @param {object} options Options overwriting the defaults
	 * @constructor
	 */
	function Module(element, options) {
		this._helper = estatico.helpers.SuperClass;

		this._helper({
			name: name,
			element: element,
			defaults: defaults,
			options: options,
			events: events,
			data: data
		});
	}

	Module.prototype = $.extend(true, {}, estatico.helpers.SuperClass.prototype, Module.prototype);

	/**
	 * Initialize module, bind events
	 */
	Module.prototype.init = function() {
		// Init dependent flex-modules
		if (estatico.modules.flexstyles &&
			(typeof (this.$element.attr('data-init')) === 'undefined' || this.$element.attr('data-init').indexOf('flexstyles') === -1)) {
			this.$element.attr('data-init', this.$element.attr('data-init') + ' flexstyles');
		}

		$document.trigger('additional_forminit', this.options);

		this._initDependentFields();
		this._initValidation();
		this._initMultistep();
		this._initAllCheckbox();

		if (!Modernizr.placeholder && typeof ($.fn.placeholder) === 'function' && this.options.initplaceholder) {
			this.$element.find('input, textarea').placeholder();
		}

		this.$element.on('change.' + name, '[data-' + this.options.dataattribute + '=showpasswordtrigger]', this._handleShowPassword.bind(this));
		this.$element.on('submit.' + name, this._handleSubmit.bind(this));

		// Readonly switch
		this.$element.on('change.' + name, 'input[type="checkbox"]', function(e) {
			if (e.originalEvent && $(e.originalEvent.target).attr('readonly')) {
				this.checked = !this.checked;
			}
		});

		// Accessibility
		var $invalidFields = $('[aria-invalid=true]:visible'); // Serverside failed validation fields

		if (this.options.validationOptions.focusInvalid) {
			$invalidFields.first().focus();
		}

		var choiceIcon = null;

		// General styles
		$invalidFields.closest('.form-set').addClass(constants.haserrorClass);
		$invalidFields.closest('.form-set').find('.form-control').addClass('form-control--invalid');
		$invalidFields.closest('.form-set').find('.form-control-label').addClass('form-control-label--invalid');
		$invalidFields.closest('.form-set').find('.form-control-subline').addClass('form-control-subline--invalid');

		// Checkbox Single
		$invalidFields.closest('.form-set').find('.choice').addClass('choice--invalid');
		choiceIcon = $invalidFields.closest('.flex_singlecheckbox').find('.choice__icon-use:first-of-type');

		if (choiceIcon.attr('xlink:href') && (choiceIcon.attr('xlink:href').search('icon-checkbox-invalid') === -1)) {
			choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-checkbox', 'icon-checkbox-invalid'));
		}

		// Checkbox Group
		$invalidFields.closest('.form-set').find('.choice').addClass('choice--invalid');
		$invalidFields = $invalidFields.closest('.flex_checkboxgroupoptions').find('.choice__icon-use:first-of-type');

		if (choiceIcon.attr('xlink:href') && (choiceIcon.attr('xlink:href').search('icon-checkbox-invalid') === -1)) {
			choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-checkbox', 'icon-checkbox-invalid'));
		}

		// Radio Group
		$invalidFields.closest('.form-set').find('.choice').addClass('choice--invalid');
		choiceIcon = $invalidFields.closest('.flex_radiogroup').find('.choice__icon-use:first-of-type');

		if (choiceIcon.attr('xlink:href') && (choiceIcon.attr('xlink:href').search('icon-radio-invalid') === -1)) {
			choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-radio', 'icon-radio-invalid'));
		}

		this.$element.on('change.' + name, 'input[type=checkbox], input[type=radio]', this._syncCheckedStatus.bind(this));

		// LLBNOVUS-874 Trigger change event for hidden fields (used for drop-select fields)
		$('.drop-select').on('click.' + name + ', touch.' + name, function(e) {
			if (e.originalEvent) {
				$(e.target).closest('.drop-select').find('input').trigger('change');
			}
		});

		$(window).on('resize.' + name, this._updateDisplayStyles.bind(this));
	};

	/**
	 * Reinits the flex-formmodule.
	 * @public
	 */
	Module.prototype.reinit = function() {
		this.$element.off('.' + name);
		this.init();
	};

	/**
	 * Method to add missing attributes like aria-invalid="true" to initial states
	 * @private
	 */
	Module.prototype._setAriaInvalid = function() {
		_.each(this.$element.find('input, textarea, select'), function(element) {
			var $element = $(element);

			/* handle checkboxes & radios */
			if (($element.attr('type') === 'checkbox' || $element.attr('type') === 'radio') && ($element.attr('required') || $element.data('val')) && !$element.attr('checked')) {
				$element.attr('aria-invalid', 'true');
				return;
			}

			/* handle the rest - textfields & selects */
			if (($element.val() === '' || $element.val() === null) && $element.attr('required')) {
				$element.attr('aria-invalid', 'true');
			}

		}, this);

		// handle change and aria-invalid state on checkboxes/radios.
		this.$element
			.on('change.' + name, this.$element.find('input[type="radio"]'), function(event) {

				var $element = $(event.target);

				if ($element.attr('type') === 'radio') {
					this.$element.find('[name="' + $element.attr('name') + '"]').attr('aria-invalid', 'false');
					return;
				}

			}.bind(this))
			.on('change.' + name, this.$element.find('input[type="checkbox"]'), function(event) {

				var $element = $(event.target);

				if ($element.attr('type') === 'checkbox' && $element.is(':checked') && $element.data('val')) {
					$element.attr('aria-invalid', 'false');
					return;
				}

				$element.attr('aria-invalid', 'true');

			}.bind(this));
	};

	/**
	 * Method to update display styles depending on the viewport (flex for width>=900, block for <900).
	 * @private
	 */
	Module.prototype._updateDisplayStyles = function() {
		var targetStyle = ($(window).width() >= 900 ? 'flex' : 'block');

		if (targetStyle !== this.options.displayStyle) {
			this.options.displayStyle = targetStyle;
			var $listItems = this.$element.find('.flex_listitem'),
				$listItem;

			$listItems.each(function(key, item) {
				$listItem = $(item);
				if ($listItem.length > 0 && $listItem.css('display') && $listItem.css('display') !== 'none') {
					$listItem.css('display', targetStyle);
				}
			});
		}
	};

	/**
	 * Method to configure Validation-Plugin if necessary and add default customValidators.
	 * @private
	 */
	Module.prototype._initValidation = function() {
		if	(!this.options.dovalidation) {
			return;
		}

		this.$element.on('invalid-form.validate.' + name, function() {
			this._setAriaInvalid();
			$document.trigger(events.EVENT_VALIDATION_INVALID, this.$element);
		}.bind(this));

		// Correct Validation for showPwd-Fields: Also textfield has to be validated, if original field is disabled.
		var $showPwd = this.$element.find('[data-' + this.options.dataattribute + '=showpassword]');

		$showPwd.each(function(index, element) {
			var $showPwdNode = $(element),
				$password = $showPwdNode.find('[type=password]'),
				$text = $showPwdNode.find('[type=text]');

			$.each($password.prop('attributes'), function() {
				// Copy data-attributes only
				if (this.name.indexOf('data-') > -1) {
					$text.attr(this.name, this.value);
				}
			});
		});

		// Extend validationOptions
		$.validator.setDefaults($.extend({}, $.validator.defaults, this.options.validationOptions));

		// Init the form with the new settings.
		var form = this.$element
			.removeData('validator') /* added by the raw jquery.validate plugin */
			.removeData('unobtrusiveValidation'); /* added by the jquery unobtrusive plugin */

		$.validator.unobtrusive.parse(form);
	};

	Module.prototype._initMultistep = function() {
		var $multistepnavigation = this.$element.find('[data-' + this.options.dataattribute + '=multistepnavigation]'),
			$items = $multistepnavigation.find('[data-' + this.options.dataattribute + '=multistepnavigationitem]');

		$items.css('width', (1 / $items.length) * 100 + '%');
	};

	/**
	 * Inits the "all" Checkbox for Checkbox-Groups.
	 */
	Module.prototype._initAllCheckbox = function() {

		/**
		this.$element.find('[data-' + name + '=all]').each(function(index, element) {
			var $checkbox = $(element),
				$group = $checkbox.closest('[data-' + name + '=allgroup]');
			this._setAllCheckbox($group);
		}.bind(this));
		 **/

		this.$element.on('change.' + name, '[data-' + name + '=allgroup]', function(event) {
			this._handleAllCheckbox(event.target);
		}.bind(this));
	};

	/**
	 * Handles one specific "All"-Checkbox
	 * @param checkbox {object} The DOM-element of the checkbox.
	 * @private
	 */
	Module.prototype._handleAllCheckbox = function(checkbox) {
		var $checkbox = $(checkbox),
			$group = $checkbox.closest('[data-' + name + '=allgroup]'),
			value = $checkbox.is(':checked');

		if ($checkbox.is('[data-' + name + '=all]')) {
			// User clicked on 'all'
			if (value) {
				$group.find(':checkbox').attr({'aria-checked': true, 'aria-invalid': false}).prop('checked', true).attr('checked', 'checked');
			} else {
				$group.find(':checkbox').attr({'aria-checked': false, 'aria-invalid': true}).prop('checked', false).removeAttr('checked');
			}
		} else {
			// User clicked on another checkbox
			this._setAllCheckbox($group);
		}
	};

	/**
	 * Sets the all-checkbox according to the state inside the group.
	 * @param $group {jQuery} The group-element.
	 * @private
	 */
	Module.prototype._setAllCheckbox = function($group) {
		var totalBoxes = $group.find(':checkbox'),
			checkedBoxes = $group.find(':checked[data-' + name + '!=all]');

		if (checkedBoxes.length === totalBoxes.length - 1) {
			$group.find('[data-' + name + '=all]').attr({'aria-checked': true, 'aria-invalid': false}).prop('checked', true).attr('checked', 'checked');
		} else {
			$group.find('[data-' + name + '=all]').attr({'aria-checked': false, 'aria-invalid': true}).prop('checked', false).removeAttr('checked');
		}
	};

	/**
	 * EventHandler for ShowPassword
	 * @param event {jQuery.event} The change-event.
	 * @private
	 */
	Module.prototype._handleShowPassword = function(event) {
		var $checkbox = $(event.currentTarget),
			$container = $checkbox.closest('[data-' + this.options.dataattribute + '=showpassword]');

		$container.find(':password:visible, :text:visible').each(function() {
			var $current = $(this),
				currentVal = $current.val();

			$current.siblings(':text, :password').val(currentVal);
		});

		$container.toggleClass(this.options.cssprefix + '_show_active', $checkbox.is(':checked'));

		// Handle Disabling Fields - Do not send invisible field, therefore disable it.
		$container.find(':password:visible, :text:visible').removeAttr('disabled').removeAttr('aria-disabled');
		$container.find(':password:hidden, :text:hidden').attr('disabled', 'disabled').attr('aria-disabled', 'true');

		if (this.options.dovalidation) {
			// Connect errorMessage to the non-disabled field
			$container.find('[data-valmsg-replace=true]').attr('data-valmsg-for', $container.find(':password:visible, :text:visible').attr('id'));
		}
	};

	/**
	 * Inits functionality for dependent fields.
	 * @method
	 * @private
	 */
	Module.prototype._initDependentFields = function() {
		var $elements = this.$element.find('[data-' + this.options.dataattribute + '-dependent]');

		if ($elements.length) {
			$elements.addClass('is-hidden');

			// Param undefined, because additional key-parameter is added as FIRST param for change-event...
			$elements.each(this._handleDependents.bind(this, undefined));

			this.$element.on('change.' + name, this._changeDependents.bind(this));

			// POSTWEPP-4416
			this.$element.find('input:selected, input:checked, select').not(':hidden').trigger('change');

		}
	};

	/**
	 * Event-Handler for the change-event of the form to handle functionality from dependent fields.
	 * @method
	 * @private
	 */
	Module.prototype._changeDependents = function(event) {
		var $changed = $(event.target).closest('[data-key]'),
			$elements;

		if ($changed.length) {
			$elements = this.$element.find('[data-' + this.options.dataattribute + '-dependent]').filter(function(i, el) {
				return _.contains($(el).data(this.options.dataattribute + '-dependent').from.split(','), $changed.data().key);
			}.bind(this));

			$elements.each(this._handleDependents.bind(this, $changed.data().key));
		}
	};

	/**
	 * Handles the show/hide of dependent elements.
	 * @param key {string} - The key of the changed element (optional).
	 * @param index {int} - The index-Parameter in .each.
	 * @param element {object} - The element-Parameter in .each.
	 * @private
	 */
	Module.prototype._handleDependents = function(key, index, element) {

		var $field = $(element),
			data = $field.data(this.options.dataattribute + '-dependent'),
			from = [],
			$from, // $from = this.$element.find('[data-key="' + data.from + '"]'),
			dependentsMatch;

		_.each(data.from.split(','), function(fromKey) {
			from.push('[data-key="' + fromKey + '"]');
		});

		$from = this.$element.find(from.join(','));

		if (data.url) {
			// Field is managed by ajax
			if (typeof key !== 'undefined') {
				this._updateField($field, data.url, key);
			} else if ($from.find(':input').val().length && $field.find('option').filter(
					function(index, option) {
						return option.value.length;
					}).length) {
				$field.removeClass('is-hidden');
			} else {
				$field.addClass('is-hidden');
				/*$field
					// ... whose options...
					.find('option')
					// ... have value
					.filter(function(index, option) {
						return option.value.length;
					})
					.remove();*/
			}

			this._updateDisplayStyles();

		} else {
			// console.log($field[0]);

			if (data.value.split('|').length > 1) {
				// OR operation: values are split by "|"
				dependentsMatch = false;

				_.each(data.value.split('|'), function(fromKey) {
					// evaluate, until there is a match
					if (!dependentsMatch) {
						dependentsMatch = $from.find(':checkbox, :radio:checked, :selected, :text, :hidden').filter(this._filterCaseInsensitiv.bind(this, fromKey)).length;
					}

					if (dependentsMatch) {
						return false;
					}
				}.bind(this));
			} else {
				// AND operation: values are split by ","
				dependentsMatch = true;

				_.each(data.value.split(','), function(fromKey) {
					// only evaluate, if there is a match until now
					if (dependentsMatch) {
						dependentsMatch = $from.find(':checkbox, :radio:checked, :selected, :text, :hidden').filter(this._filterCaseInsensitiv.bind(this, fromKey)).length;
					}
				}.bind(this));
			}

			if (dependentsMatch) {
				$field.removeClass('is-hidden').find(':input').trigger('change');
			} else {
				$field.addClass('is-hidden').find(':input').trigger('change');
			}

			if (!$from.is(':visible')) {
				$field.addClass('is-hidden');
			}
		}
	};

	/**
	 * Filters the elements from value to a given key, but caseINsensitiv.
	 * @param key {string} - The Key to match against.
	 * @param index {number} - index inside the iterator.
	 * @param element {object} - The element to compare the value.
	 * @returns {boolean} - true if value matches key (caseinsensitiv).
	 * @private
	 */
	Module.prototype._filterCaseInsensitiv = function(key, index, element) {
		var $element = $(element),
			isCheckbox = $element.is(':checkbox'),
			isChecked = $element.is(':checked'),
			keyLow = key.toLowerCase(),
			matches = false;

		if (isCheckbox && (keyLow === 'false' || keyLow === 'true')) {
			matches = isChecked.toString().toLowerCase() === keyLow;
		} else {
			if (isCheckbox && !isChecked) {
				matches = false;
			} else if (element.value) {
				matches = element.value.toLowerCase() === keyLow;
			}
		}

		return matches;
	};

	/**
	 * Updates dependentFields per Ajax, if there is an url given.
	 * @param $field {jQuery} - The field to be replaced.
	 * @param url {string} - The url to get the new field per ajax.
	 * @param key {string} - The key of the changed field.
	 * @method
	 * @private
	 */
	Module.prototype._updateField = function($field, url, key) {

		var from = $field.data(this.options.dataattribute + '-dependent').from.split(','),
			$fieldInput = $field.find(':input'),
			xhr,
			data = {},
			populateData = function(from) {
				var data1 = {};

				_.each(from, function(fromKey) {
					var $field = this.$element.find('[data-key=' + fromKey + ']'),
						$input = $field.find(':input'),
						type = $input.attr('type'),
						name = $input.attr('name'),
						hasDependent = typeof $field.data(this.options.dataattribute + '-dependent') !== 'undefined',
						from = hasDependent ? $field.data(this.options.dataattribute + '-dependent').from.split(',') : undefined;

					// POSTWEPP-4380
					if (type === 'radio' || type === 'checkbox') {
						$input = $field.find(':input:checked');
					}

					data1[name] = $input.val();
					if ($.isArray(from)) {
						$.extend(data, data1, populateData(from));
					}
				}.bind(this));

				// POSTWEPP-4346: adding dependent field value to the ajax request as well
				data1[$fieldInput.attr('name')] = $fieldInput.val();
				return data1;
			}.bind(this);

		if (!_.contains(from, key)) {
			return;
		}

		$.extend(data, populateData(from));

		if ($fieldInput.data('runningrequest')) {
			$fieldInput.data('runningrequest').abort();
		}

		xhr = $.ajax({
			method: 'get',
			url: url,
			data: data,
			success: function(response) {
				var options = '',
					optionSelected = false,
					key,
					errorList,
					validator = this.$element.validate(),
					$options = $field.find('select').find('option');

				// Remove options with value
				$options.remove();

				if ('options' in response) {
					// Append options to the select
					_.each(response.options, function(option) {
						options += '<option ';
						options += 'value="' + option.value + '"';
						options += 'selected' in option && option.selected ? ' selected="selected"' : '';
						options += '>' + option.text + '</option>';
						optionSelected = 'selected' in option && option.selected ? true : optionSelected;
					});

					$field.find('select').append(options); /*.removeClass('is-hidden').trigger('change');*/

					key = optionSelected ? $field.data().key : undefined;

					// Update dependents visibility
					this.$element.find('[data-' + this.options.dataattribute + '-dependent]').each(this._handleDependents.bind(this, key));

					// Reset summary errors messages
					this.$element.find('.validation-summary-errors')
						.addClass('validation-summary-valid')
						.removeClass('validation-summary-errors');

					$document.trigger('ajax_loaded', $field);
				} else {
					// Show some kind of error
					errorList = {
						element: $field.find(':input').get(0),
						message: response.errorMessage
					};
					validator.errorList = [errorList];

					// this.$element.validate();
					// $.validator.unobtrusive.parse(this.$element);
					$field.addClass('is-hidden');
					$(this.$element).triggerHandler('invalid-form', [validator]);
				}
			}.bind(this)
		});
		$fieldInput.data('runningrequest', xhr);

	};

	/**
	 * Handle some functions on Form submit.
	 * @param event {jQuery.event} The submit-event.
	 * @private
	 */
	Module.prototype._handleSubmit = function(event) {
		var $form = $(event.currentTarget),
			$document = $(document.documentElement),
			$showpasswordtrigger = $form.find('[data-' + this.options.dataattribute + '=showpasswordtrigger]');

		if ($showpasswordtrigger.length) {
			$showpasswordtrigger.prop('checked', false).trigger('change');
		}

		if ($document.hasClass('html-iframe')) {
			var $mainDocument = $(window.parent.document.documentElement),
				$openedModal = $mainDocument.find('.modal').not('.is-hidden');

			if ($openedModal.length === 1) {
				$openedModal.scrollTop(0);
			}
		}
	};

	/**
	 * Sets to appropriate value in aria-checked property
	 * @private
	 */
	Module.prototype._syncCheckedStatus = function(event) {
		var $inputElement = $(event.target);

		if ($inputElement.is(':radio')) {
			$(':radio[name="' + $inputElement.attr('name') + '"]').attr('aria-checked', 'false');
		}

		$inputElement.attr('aria-checked', $inputElement.prop('checked'));

		// Fix since validation is not properly triggered on data-conditional-checkbox'es
		if ($inputElement.prop('checked') && $inputElement.is('[data-conditional-checkbox]')) {
			$('[data-valmsg-for="' + $inputElement.attr('name') + '"]')
				.removeClass('field-validation-error')
				.removeClass('field-validation-invalid')
				.addClass('field-validation-valid');
		} else if ($inputElement.is('[data-conditional-checkbox]')) {
			$('[data-valmsg-for="' + $inputElement.attr('name') + '"]')
				.removeClass('field-validation-valid')
				.addClass('field-validation-error')
				.addClass('field-validation-invalid');
		}
	};

	/**
	 * Unbind events, remove data, custom teardown
	 * @method
	 * @public
	 */
	Module.prototype.destroy = function() {
		// Unbind events, remove data
		estatico.helpers.SuperClass.prototype.destroy.apply(this);

		// Custom teardown (removing added DOM elements etc.)
		// If there is no need for a custom teardown, this method can be removed
	};

	// Make the plugin available through jQuery (and the global project namespace)
	estatico.helpers.SuperClass.register(Module, name, {
		initEvents: ['ready', 'ajaxload'],
		events: events
	});

	// Only once: Configure Validator
	if ($.validator && $.validator.unobtrusive) {

		// Add / remove additional classes
		$.validator.defaults.highlight = function(element) {
			var choiceIcon = null;

			// General styles
			$(element).closest('.form-set').addClass(constants.haserrorClass);
			$(element).closest('.form-set').find('.form-control').addClass('form-control--invalid');
			$(element).closest('.form-set').find('.form-control-label').addClass('form-control-label--invalid');
			$(element).closest('.form-set').find('.form-control-subline').addClass('form-control-subline--invalid');

			// Checkbox Single
			$(element).closest('.form-set').find('.choice').addClass('choice--invalid');
			choiceIcon = $(element).closest('.flex_singlecheckbox').find('.choice__icon-use:first-of-type');

			if (choiceIcon.attr('xlink:href') && (choiceIcon.attr('xlink:href').search('icon-checkbox-invalid') === -1)) {
				choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-checkbox', 'icon-checkbox-invalid'));
			}

			// Checkbox Group
			$(element).closest('.form-set').find('.choice').addClass('choice--invalid');
			choiceIcon = $(element).closest('.flex_checkboxgroupoptions').find('.choice__icon-use:first-of-type');

			if (choiceIcon.attr('xlink:href') && (choiceIcon.attr('xlink:href').search('icon-checkbox-invalid') === -1)) {
				choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-checkbox', 'icon-checkbox-invalid'));
			}

			// Radio Group
			$(element).closest('.form-set').find('.choice').addClass('choice--invalid');
			choiceIcon = $(element).closest('.flex_radiogroup').find('.choice__icon-use:first-of-type');

			if (choiceIcon.attr('xlink:href') && (choiceIcon.attr('xlink:href').search('icon-radio-invalid') === -1)) {
				choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-radio', 'icon-radio-invalid'));
			}
		}.bind(this);

		$.validator.defaults.unhighlight = function(element) {
			var choiceIcon = null;

			// General styles
			$(element).closest('.form-set').removeClass(constants.haserrorClass);
			$(element).closest('.form-set').find('.form-control--invalid').removeClass('form-control--invalid');
			$(element).closest('.form-set').find('.form-control-label--invalid').removeClass('form-control-label--invalid');
			$(element).closest('.form-set').find('.form-control-subline--invalid').removeClass('form-control-subline--invalid');

			// Checkbox Single
			$(element).closest('.form-set').find('.choice--invalid').removeClass('choice--invalid');
			choiceIcon = $(element).closest('.flex_singlecheckbox').find('.choice__icon-use:first-of-type');

			if (choiceIcon.attr('xlink:href')) {
				choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-checkbox-invalid', 'icon-checkbox'));
			}

			// Checkbox Group
			$(element).closest('.form-set').find('.choice--invalid').removeClass('choice--invalid');
			choiceIcon = $(element).closest('.flex_checkboxgroupoptions').find('.choice__icon-use:first-of-type');

			if (choiceIcon.attr('xlink:href')) {
				choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-checkbox-invalid', 'icon-checkbox'));
			}

			// Radio Group
			$(element).closest('.form-set').find('.choice--invalid').removeClass('choice--invalid');
			choiceIcon = $(element).closest('.flex_radiogroup').find('.choice__icon-use:first-of-type');

			if (choiceIcon.attr('xlink:href')) {
				choiceIcon.attr('xlink:href', choiceIcon.attr('xlink:href').replace('icon-radio-invalid', 'icon-radio'));
			}
		}.bind(this);

		// http://weblogs.asp.net/imranbaloch/overriding-unobtrusive-client-side-validation-settings-in-asp-net-mvc-3
		// var validator = this.$element.data('validator');

		// deactivate email => it's done by regex (because default email-regex isn't good)
		$.validator.methods.email = function() {
			return true;
		};

		// Add Mandatory for Checkboxes, as they don't support 'required' (POSTSC-5)
		// http://stackoverflow.com/questions/4934032/mvc3-make-checkbox-required-via-jquery-validate
		$.validator.unobtrusive.adapters.add('mandatory', function(options) {
			options.rules.required = true;
			if (options.message) {
				options.messages.required = options.message;
			}
		});

		$.validator.unobtrusive.adapters.addBool('mandatory', 'required');

		// We can't write mandatory in Backend, so we do here.
		var $requiredCheckboxes = $(':checkbox[data-val-required]');

		$requiredCheckboxes.each(function() {
			var $checkbox = $(this);

			$checkbox.attr('data-val-mandatory', $checkbox.attr('data-val-required'));
			$checkbox.removeAttr('data-val-required');
		});

		// Multicheckrequired
		$.validator.unobtrusive.adapters.add('multicheckrequired', [], function(options) {
			options.rules.multicheckrequired = true;
			options.messages.multicheckrequired = options.message;
		});

		$.validator.addMethod('multicheckrequired', function(value, element) {
			var $container = $(element).closest('fieldset');

			return $container.find(':checked').length ? true : false;
		});

		// Custom Filerequired
		$.validator.unobtrusive.adapters.add('filerequired', [], function(options) {
			options.rules.filerequired = true;
			options.messages.filerequired = options.message;
		});

		$.validator.addMethod('filerequired', function(value, element) {
			var hasCurrentFile = $(element).closest('[data-init=flexfileinput]').find('[data-flexfileinput=current]').length;

			return value !== '' || hasCurrentFile;
		});
	}

})(jQuery);
